import React, { useState } from 'react';
import classnames from 'classnames';
import './CommonInput.css';
import NewSpinner from '../../../common/components/NewSpinner/NewSpinner';

function CommonInput({
  name,
  max,
  min,
  maxLength,
  id,
  type = 'text',
  legendName,
  placeholder,
  value,
  onChange,
  onBlur,
  onKeyUp,
  onKeyDown,
  onKeyPress,
  disabled,
  error,
  errorMsg,
  touched,
  stylesContainer = {},
  legendStyle = {},
  inputStyle = {},
  onBlurStyle = {},
  fieldsetStyle = {},
  showLoading,
  inputContainerRef = '',
  LoadingComponent = NewSpinner
}) {
  const [isFocussed, setIsFocussed] = useState(false);
  const inputRef = React.useRef(null);
  const legendRef = React.useRef(null);

  const commonInputProps = {
    name,
    max,
    min,
    type,
    id,
    value,
    onChange,
    onKeyUp,
    onKeyDown,
    onKeyPress,
    maxLength,
    placeholder,
    onFocus: () => {
      setIsFocussed(true);
      legendRef.current.style.position = 'relative';
      legendRef.current.style.top = '-14px';
      legendRef.current.style.transition = 'all .3s';
      legendRef.current.style.fontSize = '12px';
      legendRef.current.style.paddingLeft = '0px';
    },
    onBlur: e => {
      setIsFocussed(false);
      if (onBlur) {
        onBlur(e);
      }
      if (!value && !showLoading) {
        legendRef.current.style.position = 'absolute';
        legendRef.current.style.top = '17px';
        legendRef.current.style.transition = '';
        if (onBlurStyle.paddingLeft) {
          legendRef.current.style.paddingLeft = onBlurStyle.paddingLeft;
        }
      }
    },
    className: `input_box w-11/12 bg-white  
      rounded-l-md hover:border font-normal font-roboto text-sm px-4
       ${disabled ? 'cursor-not-allowed text-black-600 ' : ''}`,
    ref: inputRef
  };

  const fieldSetClasses = classnames(
    `fieldset_box  h-full w-full rounded bg-white  
        ${
          disabled
            ? 'hover:border hover:border-grey-350 '
            : 'hover:border hover:border-green-600'
        }`,
    {
      'border border-red-300': error && touched,
      'border border-green-600': (!error && touched) || isFocussed,
      'border border-grey-350': !touched
    }
  );
  const inputContainer = () =>
    inputContainerRef
      ? {
          ref: inputContainerRef
        }
      : {};
  return (
    <div className={`input_container w-full py-auto `} style={stylesContainer}>
      <fieldset className={fieldSetClasses} style={fieldsetStyle}>
        <div
          style={{
            position:
              value || isFocussed || showLoading ? 'relative' : 'absolute',

            top: value || isFocussed ? '-14px' : '17px',
            marginLeft: value || isFocussed ? '17px' : '24px',
            display: 'inline-block',
            // padding: value ? "0px 1px" : "0px",
            background: '#fff',
            zIndex: 1,
            ...legendStyle
          }}
          ref={legendRef}
          onClick={() => {
            inputRef.current.focus();
          }}
          className={`ml-6 border-black  ${
            value ? 'text-xs' : 'text-sm'
          } font-roboto text-black-600 font-nomal ${
            error ? 'text-red-300' : ''
          }`}
        >
          {legendName}
        </div>

        <div className="flex w-full " {...inputContainer()}>
          {!disabled ? (
            <input {...commonInputProps} style={inputStyle} />
          ) : (
            <input {...commonInputProps} disabled style={inputStyle} />
          )}
          {showLoading && (
            <div
              className="absolute self-center  "
              style={{ width: 'fit-content', right: '4px' }}
            >
              <LoadingComponent />
            </div>
          )}
        </div>
      </fieldset>
      {error && errorMsg && (
        <div className="mt-1 text-xs text-red-300 ">{errorMsg}</div>
      )}
    </div>
  );
}

export default CommonInput;
